import { render, staticRenderFns } from "./AssignmentEditor.vue?vue&type=template&id=06f56f83"
import script from "./AssignmentEditor.vue?vue&type=script&lang=js"
export * from "./AssignmentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports